import React, { useRef } from 'react';
import { Column, Row, Screen, CircularProgress } from '@tempmee/react';
import { enableChatsUnread } from '../growthbook';
import { Chat } from './Inbox/Chat/Chat';
import Messages from './messages/Messages';
import history from '~/browserHistory';
import { useConversations } from '~/domain/Messages';
import { useInfiniteScrollTrigger } from '~/hooks';
import { IConversation } from '~/models';

export default function Inbox() {
  const isEnableChatUnread = useRef(enableChatsUnread()).current;

  const { conversations, isLoading, isFinalPage, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useConversations({ filter: 'all', enabled: !isEnableChatUnread });

  const refMessages = useRef<HTMLDivElement>(null);

  const triggerFetchNextPage = useInfiniteScrollTrigger({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const handleScrollMessages = () => {
    const el = refMessages.current;
    if (!el) return;

    triggerFetchNextPage(el.scrollHeight - el.scrollTop <= el.clientHeight);
  };

  const selectedMessage = (job: IConversation) => {
    history.push(`/dashboard/chat/${job.id}`, { jobId: job.id });
  };

  const renderMessageContent = () => {
    if (isEnableChatUnread) {
      return <Chat isRootComponent />;
    }

    return (
      <Column
        ref={refMessages}
        onScroll={handleScrollMessages}
        style={{ overflowY: 'scroll', maxHeight: 500 }}
      >
        <Messages
          conversations={conversations}
          isLoading={isLoading}
          selectedJobs={selectedMessage}
        />
        {!isFinalPage && isFetchingNextPage ? (
          <Row align="center" justify="center" style={{ width: '100%', height: 100 }}>
            <CircularProgress />
          </Row>
        ) : null}
      </Column>
    );
  };

  return (
    <Screen variant="standard">
      <Screen.Header title="Inbox" />
      <Screen.Body>{renderMessageContent()}</Screen.Body>
    </Screen>
  );
}
